import React from "react";
import { PROCESS_STEPS } from "@/mock";

const ProcessSection = () => {
  return (
    <section
      data-testid="process-section"
      className="py-24 lg:py-32 bg-brand-subtle border-y border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-4 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              How it works
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-brand-ink leading-[0.95]">
              Four steps. <br />
              <span className="italic font-light">No surprises.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base lg:text-lg text-brand-inkSoft leading-relaxed">
              We've fine-tuned this process across 600+ remodels. You'll always
              know what's happening, what's next, and what it costs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-border border border-brand-border">
          {PROCESS_STEPS.map((step, i) => (
            <div
              key={step.n}
              data-testid={`process-step-${i}`}
              className="bg-brand-bg p-10 lg:p-12 flex flex-col gap-5 min-h-[280px]"
            >
              <span className="font-heading text-5xl font-black text-brand-cta tracking-tighter">
                {step.n}
              </span>
              <h3 className="font-heading text-xl font-bold tracking-tight text-brand-ink">
                {step.title}
              </h3>
              <p className="text-sm text-brand-inkSoft leading-relaxed">
                {step.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
